import { ProductBookEntity } from "~/constants/forms";

export const isProductUnitValue = field =>
  field === ProductBookEntity.UNIT_VALUE;

export const isProductUnitWeight = field =>
  field === ProductBookEntity.UNIT_WEIGHT;
